import config from "./configuration";

async function request(path = "", method = "GET", body, signal) {
  let token = "";
  try { token = JSON.parse(localStorage.getItem("userData") || "{}").token || ""; } catch (_) {}
  const response = await fetch(`${config.BASE_URL.replace(/\/$/, "")}/api/admin/menu-configuration${path}`, {
    method, signal, cache: "no-store",
    headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || result.status !== 200) throw Object.assign(new Error(result.message || "Unable to load menu configuration."), { status: response.status });
  return result.data;
}
const service = {
  load: (signal) => request("", "GET", undefined, signal),
  createRole: (body) => request("/roles", "POST", body),
  updateRole: (id, body) => request(`/roles/${encodeURIComponent(id)}`, "PUT", body),
  deleteRole: (id, revision) => request(`/roles/${encodeURIComponent(id)}`, "DELETE", { revision }),
  saveMenus: (id, body) => request(`/roles/${encodeURIComponent(id)}/menus`, "PUT", body),
};
export default service;
